import { render, staticRenderFns } from "./MatchBar.vue?vue&type=template&id=4f9d21b6&scoped=true&"
import script from "./MatchBar.vue?vue&type=script&lang=js&"
export * from "./MatchBar.vue?vue&type=script&lang=js&"
import style0 from "./MatchBar.vue?vue&type=style&index=0&id=4f9d21b6&prod&lang=css&"
import style1 from "./MatchBar.vue?vue&type=style&index=1&id=4f9d21b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d21b6",
  null
  
)

export default component.exports